var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column mb-6"},[_c('update',{staticClass:"ma-5"}),_c('hr',{staticClass:"soft"}),_c('disable-store',{staticClass:"ma-5"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }